import { Button, styled, TextField } from '@mui/material'
import React, { useState } from 'react'

const Form = styled('form')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(1),
}))

export type FormInputs = {
  title: string
  content: string
}

type FormProps = FormInputs & {
  submitTitle: string
  onSubmit: (inputs: FormInputs) => void
}

const NForm = (props: FormProps) => {
  const [title, setTitle] = useState(props.title)
  const [content, setContent] = useState(props.content)

  const { submitTitle } = props
  const isValid = ![title, content].includes('')

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    props.onSubmit({ title, content })
  }

  return (
    <Form noValidate onSubmit={(e) => onSubmit(e)}>
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        label="タイトル"
        type="text"
        autoFocus
        value={title}
        onChange={({ target }) => setTitle(target.value)}
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        multiline
        minRows="5"
        maxRows="20"
        label="内容"
        type="text"
        value={content}
        onChange={({ target }) => setContent(target.value)}
      />
      <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 3, mb: 2 }} disabled={!isValid}>
        {submitTitle}
      </Button>
    </Form>
  )
}

export default NForm
